module.exports = __webpack_public_path__ + "media/images/flags/ke-74aaf58557811d8e79ab93e6e0a2d3f5.svg";